<template>
  <modal v-on:closeModalRequest="closeModalRequest()">
    <div class="modal-change-name scrollable -y">
      <div class="header">
        <div class="title">Change Name</div>
      </div>
      <form
      v-on:submit="onClickSubmit"
      class="body">
        <div class="content">
          <div class="info-container">
            <div class="label">First name</div>
            <input id="first-name" type="text" v-model="firstName" ref="first-name">
          </div>
          <div class="info-container">
            <div class="label">Last name</div>
            <input id="last-name" type="text" v-model="lastName">
          </div>
          <div class="action-btns flex-end">
            <div
            v-on:click="closeModalRequest()" ontouchstart=""
            class="action-btn">Cancel</div>
            <input
            id="update-name"
            type="submit" value="Update"
            class="action-btn blue" />
          </div>
        </div>
      </form>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal'
export default {
  name: 'modal-change-name',
  components: {
    Modal
  },
  computed: {
    myFirstName: function () {
      return this.$store.getters.myFirstName
    },
    myLastName: function () {
      return this.$store.getters.myLastName
    }
  },
  data: function () {
    return {
      firstName: null,
      lastName: null
    }
  },
  created: function () {
    this.initInputs()
    this.setInputFocused()
  },
  methods: {
    closeModalRequest: function (reload = false) {
      this.$emit('closeModalRequest')
      if (reload) setTimeout(() => { this.getMyProfile() }, 1000)
    },
    onClickSubmit: function (e) {
      e.preventDefault()
      this.updateMyProfile().then(
        success => {
          this.closeModalRequest(true)
        },
        failure => {
          this.closeModalRequest(true)
        }
      )
    },
    setInputFocused: function () {
      this.$nextTick(() => {
        if (this.$refs['first-name']) {
          this.$refs['first-name'].focus()
        } else {
          setTimeout(() => {
            if (this.$refs['first-name']) {
              this.$refs['first-name'].focus()
            }
          }, 1000)
        }
      })
    },
    initInputs: function () {
      this.firstName = this.myFirstName
      this.lastName = this.myLastName
    },
    getMyProfile: function () {
      return this.$store.dispatch('getMyProfile')
    },
    updateMyProfile: function () {
      let firstName = this.firstName
      let lastName = this.lastName
      return this.$store.dispatch('updateMyProfile', {firstName, lastName})
    }
  }
}
</script>

<style scoped>
.modal-change-name {
  /* common */
  background-color: hsla(0, 100%, 100%, 1);
  border: 1px solid var(--blue-gray-medium);
  border-radius: 5px;
  /* size */
  max-width: 500px;
  max-height: 100%;
  width: 100%;
}

.modal-change-name .header {
  /* common */
  font-size: 14px;
  /* size */
  padding: 20px 32px 20px;
  /* text */
  font-weight: bold;
  /* alignment */
  text-align: left;
}
.modal-change-name .header .title {
  /* common */
  font-size: 2em;
}
.modal-change-name .header .description {
  /* common */
  font-size: 1em;
  /* text */
  font-weight: normal;
}


.modal-change-name .body {
  /* size */
  padding: 0 32px;
  /* border */
  border-top: 1px solid hsla(0, 100%, 0%, 0.1);
  /* alignment */
  text-align: left;
}

.modal-change-name .body .content {
  /* common */
  color: #000;
  font-size: 16px;
  /* size */
  width: 100%;
  min-height: 4em;
  margin: 16px 0;
  /* border */
  /* outline: 1px solid red; */
}


.modal-change-name .body .content .info-container:first-child {
  margin-top: 0;
}
.modal-change-name .body .content .info-container {
  /* size */
  margin: 1em 0;
}
.modal-change-name .body .content .info-container .label {
  font-size: 14px;
  color: var(--gray-high);
  text-align: start;
  margin-bottom: 10px;
}
.modal-change-name .body .content .info-container > input {
  /* common */
  border: solid 1px#e6e6e6;
  border-radius: 5px;
  /* size */
  width: calc(100% - 1em);
  padding: 0.5em;
  font-size: 16px;
  /* padding: 10px; */

  -webkit-transition: -webkit-box-shadow .3s;
  transition: -webkit-box-shadow .3s;
  transition: box-shadow .3s;
  transition: box-shadow .3s,-webkit-box-shadow .3s;
}




.modal-change-name .body .content .action-btns {
  /* size */
  margin: 1em 0 2em;
  /* alignment */
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

</style>



// WEBPACK FOOTER //
// src/components/Modal/ModalChangeName.vue